import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";

const UseMobile = () => {
  const [state, setState] = React.useState();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only(["sm", "xs"]));

  return isMobile;
};
export default UseMobile;
